import { createTableFilterSlice } from 'common/stores/redux/TableFilter';

const adminBusinessChannelFilterSlice = createTableFilterSlice(
    'adminBusinessChannelFilter'
);

export const { add, replace, remove, addAdvanced, removeAll } =
    adminBusinessChannelFilterSlice.actions;

export default adminBusinessChannelFilterSlice.reducer;
